import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthoritiesPage } from './authorities.page';

const routes: Routes = [
  {
    path: '',
    component: AuthoritiesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthoritiesPageRoutingModule {}
